let _ = t => t,
  _t;
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { css } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const linkStyles = css(_t || (_t = _`
  flex-direction: column;
  height: 100%;
  color: inherit;
  font: inherit;
  line-height: inherit;
  text-decoration: inherit;
  display: flex;
  -webkit-font-smoothing: auto;
  :hover {
    color: inherit;
    font: inherit;
    line-height: inherit;
    text-decoration: inherit;
  }
`));
const FlexLink = styled(Link).withConfig({
  displayName: "TrackCardLink__FlexLink",
  componentId: "qige6m-0"
})(["", ""], linkStyles);
const ExternalLink = styled.a.withConfig({
  displayName: "TrackCardLink__ExternalLink",
  componentId: "qige6m-1"
})(["", ""], linkStyles);
const CardHolder = styled.div.withConfig({
  displayName: "TrackCardLink__CardHolder",
  componentId: "qige6m-2"
})(["display:flex;flex-direction:column;height:100%;"]);
const TrackCardLink = ({
  children,
  deprecated,
  to,
  href
}) => {
  if (deprecated || !to && !href) {
    return /*#__PURE__*/_jsx(CardHolder, {
      children: children
    });
  }
  if (to) {
    return /*#__PURE__*/_jsx(FlexLink, {
      to: to,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(ExternalLink, {
    href: href,
    children: children
  });
};
export default TrackCardLink;